import { FC, PropsWithChildren } from "react";
import { Typography } from "@mui/material";
import styled from "@emotion/styled";
import { ScreenSize } from "@constants/screen-size";

const Container = styled.div<{ accentColor?: string }>`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 16px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.07);
  padding: 24px 32px;
  background-color: #ffffff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  ${({ accentColor }) =>
    accentColor ? `border-left: 4px solid ${accentColor};` : ""}

  @media (max-width: ${ScreenSize.md}px) {
    padding: 16px;
  }
`;

const DashboardTile: FC<
  PropsWithChildren<{
    filled?: boolean;
    title?: string;
    accentColor?: string;
  }>
> = ({ children, title, accentColor }) => {
  return (
    <Container accentColor={accentColor}>
      {title && (
        <Typography
          variant="h6"
          fontWeight="500"
          marginBottom="24px"
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
        >
          {title}
        </Typography>
      )}
      {children}
    </Container>
  );
};

export default DashboardTile;
